import Fieldset from "../../../Global/Forms/Fieldset";

import { useTranslation } from "react-i18next";

/**
 * 
 * @exports CreateAction
 * 
 * @description CreateAction component.
 * 
 * @param { Object } props - The props object.
 * 
 * @param { Object } props.errors - The errors object.
 * 
 * @param { Boolean } props.loading - The loading state.
 * 
 * @example <CreateAction errors={ errors } loading={ loading } />
 * 
 * @returns { JSX.Element } CreateAction
 * 
 */

export default function CreateAction ( { errors, loading } ) { const 

    { t : __ } = useTranslation ();

    /** @returns { JSX.Element } CreateAction */

    return (

        <Fieldset legend={ "actions" }>

            {

                errors?.message &&

                <div className="errors">

                    <div className="error">

                        { errors?.message || "Internal Server Error" }

                    </div>

                </div>

            }

            <button className="button" disabled={ loading }>

                { __ ( "submit" ) }

            </button>

        </Fieldset>

    );

};